module.exports = __webpack_public_path__ + "img/fc_platinum.dfc19f09.png";